const filterUtils = {
  methods: {
    filterHasValue (f) {
      return f.multiple ? f.value.length > 0 : f.value !== null
    },
    getActiveCount (filters) {
      return filters.filter(f => !f.external && this.filterHasValue(f)).length
    }
  }
}

export default filterUtils
